module.exports = __webpack_public_path__ + "img/cxa.4c001231.png";